module.exports = __webpack_public_path__ + "static/media/skale-icon-nov-14-2024-2.b756ec0e.gif";